var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 27,
    viewBox: "0 0 22 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.9592 4.67644V1.99051C9.9592 1.27496 10.5399 0.694214 11.2555 0.694214C11.9697 0.694214 12.5518 1.27496 12.5518 1.99051V4.67644C14.4781 4.95384 16.2786 5.84829 17.6708 7.24051C19.3729 8.94254 20.3296 11.2512 20.3296 13.6571V18.5365L21.3783 20.6338C21.8799 21.6385 21.8268 22.831 21.2357 23.7865C20.6458 24.7418 19.6024 25.3238 18.4797 25.3238H12.5518C12.5518 26.0394 11.9697 26.6201 11.2555 26.6201C10.5399 26.6201 9.9592 26.0394 9.9592 25.3238H4.03125C2.90736 25.3238 1.86386 24.7418 1.27405 23.7865C0.68293 22.831 0.629771 21.6385 1.13273 20.6338L2.18142 18.5365V13.6571C2.18142 11.2512 3.13682 8.94254 4.83886 7.24051C6.23238 5.84829 8.03161 4.95384 9.9592 4.67644ZM11.2555 7.17569C9.53531 7.17569 7.88775 7.85884 6.67182 9.07477C5.45589 10.2894 4.77401 11.9382 4.77401 13.6571V18.8424C4.77401 19.0432 4.72607 19.2416 4.63662 19.4218C4.63662 19.4218 4.05977 20.5755 3.4505 21.7927C3.35069 21.9937 3.36107 22.2335 3.47902 22.424C3.59699 22.6146 3.80569 22.7312 4.03125 22.7312H18.4797C18.7041 22.7312 18.9127 22.6146 19.0307 22.424C19.1486 22.2335 19.1591 21.9937 19.0593 21.7927C18.4499 20.5755 17.8731 19.4218 17.8731 19.4218C17.7836 19.2416 17.7369 19.0432 17.7369 18.8424V13.6571C17.7369 11.9382 17.0538 10.2894 15.8379 9.07477C14.6219 7.85884 12.9744 7.17569 11.2555 7.17569Z",
    fill: "#DA2128"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.e45f678bbfe4a182f8abb6be90eb722f.svg";
export { ForwardRef as ReactComponent };